<app-admin-form [title]="'Leveranciers Inkoop Kortingen'">
  

</app-admin-form>